import store from '@js/store'
import {
    LiveSearch,
    CollectionComponent,
    ContinuousCollectionComponent,
    SyncsWithUrl,
    ResetsPage
} from 'clockvine-vue'

import KeywordSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from "axios";

import useFocusable from '@js/mixins/focusable'
import { until } from '@js/utility/until'

export default {
    store,

    delimiters: ['${', '}'],

    mixins: [
        new SyncsWithUrl('params', {
            page: () => false,
            search: () => true,
            orderBy: 'title asc',
        }),
        new ResetsPage(),
        useFocusable,
    ],

    data: {
        params: {
            sortOrder: '',
            orderBy: '',
            page: 1,
            search: '',
            division: '',
            type: '',
            category: '',
            audience: '',
            keyword: ''
        },
        filtersOpen: false,
        searchTerm: 'h',
        isLoading: false,
        keywordOptions:[],
    },

    mounted() {
        this.searchTerm = this.params.search
        this.setKeywordOptions()

        // document.onreadystatechange = function () {
        //     if (document.readyState == "complete") {
        //         const loadOnScroll = (entries, observer) => {
        //             console.log(entries[0].target.id)
        //         }

        //         const divisionObserver = new IntersectionObserver(loadOnScroll)
        //         const jumpLinks = document.querySelectorAll('.jumpLinks__listItem a')
        //         jumpLinks.forEach(el => {
        //             const divisionId = el?.href.split('#')[1]
        //             const divisionEl = document.querySelector(divisionId)
        //             divisionObserver.observe(divisionEl)
        //         })

        //     }
        // }



    },

    computed: {
        categories: {
            get () {
                return this.params.category.length
                    ? this.params.category.split(',')
                    : []
            },
            set (value) {
                this.params.category = value.length ? value.join(',') : ''
            },
        },
        leadershipDivisions: {
            get () {
                return this.params.division.length
                    ? this.params.division.split(',')
                    : []
            },
            set (value) {
                this.params.division = value.length ? value.join(',') : ''
            },
        },
        types: {
            get () {
                return this.params.type.length
                    ? this.params.type.split(',')
                    : []
            },
            set (value) {
                this.params.type = value.length ? value.join(',') : ''
            },
        },
        keywords: {
            get () {
                return this.params.keyword.length
                    ? this.params.keyword.split(',')
                    : []
            },
            set(value) {
                this.params.keyword = value.length ? value.join(',') : ''
            },
        },
        keywordLabel() {
            return this.keywordOptions.filter( keyword => {
                if ( this.keywords.includes( keyword.code ) ) {
                    return keyword
                }

            })
        },
        urlContainsFilters() {
            const urlParams = new URLSearchParams(window.location.search);
            return (
                urlParams.has('search') ||
                urlParams.has('category') ||
                urlParams.has('division') ||
                urlParams.has('type') ||
                urlParams.has('audience') ||
                urlParams.has('keyword')
            )
        },
        hasFilters() {
            return (
                this.params.category.length ||
                this.params.division.length ||
                this.params.type.length ||
                this.params.audience.length ||
                this.searchTerm.length ||
                this.params.keyword.length
            );
        },
    },

    methods: {
        openFilters () {
            this.filtersOpen = true
        },

        closeFilters () {
            this.filtersOpen = false
        },

        filteredCategoriesBySlugs (categories, slugs) {
            return categories.filter(category => slugs.includes(category.slug))
        },

        searchQuery () {
            this.params.search = this.searchTerm
        },

        nextPage () {
            this.params.page += 1
            this.updateElementFocus()
        },

        clearSearch () {
            this.params.search = ''
            this.searchTerm = ''
            this.$refs.filteringSearchInput.focus()
        },

        clearFilters () {
            this.params.category = ''
            this.params.division = ''
            this.params.type = ''
            this.params.audience = ''
            this.keywords = ''
        },
        getFilteredItems(items, searchBy = 'name'){
            if(items && items.length){
                this.isLoading = false
                return items.filter(item => {
                    return item[searchBy].toLowerCase().includes(this.searchTerm.toLowerCase())
                })
            }
            else {
                this.isLoading = true
                return []
            }
        },
        goToAnchor(event){
            window.location.href = event.target.value
        },
        setKeywordOptions() {
            let _self = this;

            axios({
                method: "get",
                url: "/keyword-tags.json",
                params: { q: this.searchTerm }
            })
            .then(response => {
                _self.keywordOptions = response.data.data;
            })
            .catch(error => {});
        },

        updateKeyword(value) {
            this.keywords = value ? [value.code] : ''
        },

        updateElementFocus() {
            const lists = document.querySelectorAll('[data-paginated-focus-update]')
            lists?.forEach((list) => {
                if (!list.dataset.paginatedFocusUpdate) { return }
                const pageSize = Number(list.dataset.paginatedFocusUpdate)
                const observer = new MutationObserver(([mutation], _observer) => {
                    if (!mutation.addedNodes.length || mutation.target.children.length <= pageSize) { return }
                    _observer.disconnect()
                    const nextFocus = mutation.target.children[pageSize]
                    const firstFocusableElement = this.queryFirstFocusableElement(nextFocus)
                    firstFocusableElement.focus()
                    setTimeout(() => {
                        firstFocusableElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    }, 100)
                    list.dataset.paginatedFocusUpdate = list.children.length
                })
                observer.observe(list, { childList: true })
            })
        },

        filterLeadership(leaders, divisionSlug) {
            if (leaders && leaders.length) {
                // Filter by division
                let divisionLeaders = leaders.filter(leader => leader.divisions.some(division => division.slug == divisionSlug));

                // Split into managing directors and non-directors
                let managingDirectors = divisionLeaders.filter(leader => leader.managingDirector)
                    .sort((a, b) => a.lastName.localeCompare(b.lastName));

                let nonDirectors = divisionLeaders.filter(leader => !leader.managingDirector)
                    .sort((a, b) => a.lastName.localeCompare(b.lastName));

                // Combine
                return [...managingDirectors, ...nonDirectors];
            } else {
                return leaders
            }
        }
    },

    components: {
        audiences: CollectionComponent.for('audiences'),
        leadership: CollectionComponent.for('leadership'),
        divisions: CollectionComponent.for('divisions'),
        news: CollectionComponent.for('news'),
        newsCategories: CollectionComponent.for('newsCategories'),
        resources: ContinuousCollectionComponent.for('resources'),
        resourceTypes: CollectionComponent.for('resourceTypes'),
        resourceDivisions: CollectionComponent.for('resourceDivisions'),
        keywordSearch: KeywordSelect,
    },
    watch: {
        searchTerm: {
            handler: function (after, before) {
                this.setKeywordOptions();
            },
            deep: true
        },

    },
}
